var KSV = (function () {
	"use strict";

	var navigationFixed = false,
		headerHeight;

	return {
		Initialise: function () {

			KSV.Menus();

			objectFitImages();

			$('.sub-nav-button').on('click', KSV.SubNav);

			$('.fancybox').attr('rel', 'gallery[]').fancybox({
				openEffect: 'fade',
				closeEffect: 'fade',
				nextEffect: 'none',
				prevEffect: 'none',
				padding: 0,
				theme: 'dark'
			});

			$('.tab-nav a').on('click', function(event) {
				if ( ! $(this).hasClass('tab--link') ) {
					$('.tabs .active').removeClass('active');
					$(this).addClass('active');
					$($(this).attr('href')).addClass('active');
					event.preventDefault();
				}
			});

			headerHeight = $('.top-cta').outerHeight();
			if ( $('.sub-pages--placeholder').length > 0 && $('.sub-pages--placeholder').css('display') === 'block' ) {
				$(window).on('load scroll', KSV.Header);
				KSV.Header();
			}

			$('.drinks__navigation a').on('click', function(event) {
				var $to = $( $(this).attr( 'href' ) );
				if ( $to.length > 0 ) {
					$('html, body').animate({scrollTop: $to.offset().top - 240}, 1500);
				}
				event.preventDefault();
			});

			$('[href="#get-a-quote"]').on('click', function(event) {
				var $to = $('.get-a-quote');
				if ( $to.length > 0 ) {
					if ( $to.css('display') === 'none' ) {
						$to.slideDown('slow');
					}

					$('html, body').animate({scrollTop: $to.offset().top - 220}, 1500);

					event.preventDefault();
				}
			});

			if ( $('#map').length > 0 ) {
				KSV.MapLoad();
			}

		},

		Menus: function () {

			$( '.main-nav .menu-item' ).parent().prepend( '<button class="menu-toggle"></button>' );

			$( document.body ).on( 'click', '.menu-toggle', function () {
				$( this ).parent().toggleClass( 'menu-open' );
			});

			$( '.navicon' ).on( 'click', function () {
				$( document.body ).toggleClass( 'main-nav-open' );
			});

			if ( $( window ).width() >= 768 ) {
				$( '.main-nav li:has(ul)' ).doubleTapToGo();
			}

			$('.main-nav select')
				.on('click', function() {
					$(this).closest('.menu-item').parent().addClass('show-menu');
				})
				.on('change', function() {
					var $el = $(this).closest('.menu-item').parent();
					setTimeout(function() {
						$el.removeClass('show-menu');
					}, 1000);
				});

		},

		SubNav: function(event) {
			$( '.sub-pages' ).toggleClass( 'sub-nav-open' );
			event.preventDefault();
		},

		Header: function() {
			var scrollTop = $(window).scrollTop();
			if ( scrollTop >= headerHeight ) {
				if ( ! navigationFixed ) {
					KSV.Helpers.addClass(document.body, 'sub-nav-sticky');
				}
				navigationFixed = true;
			} else {
				if ( navigationFixed ) {
					KSV.Helpers.removeClass(document.body, 'sub-nav-sticky');
				}
				navigationFixed = false;
			}
		},

		MapLoad: function () {

			var element = document.createElement( 'script' );
			element.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&callback=KSV.MapInit&key=AIzaSyDhRv0umy_C6q9jtktoGTWm-qrWFeHdJMQ';
			document.body.appendChild( element );

		},

		MapInit: function () {

			var center = new google.maps.LatLng( 50.987294, 0.136692 ),
				mapOptions = {
					zoom: 16,
					center: center,
					minZoom: 6,
					maxZoom: 18,
					mapTypeControl: false,
					scrollwheel: false
				},
				styles = [
					{
						stylers: [
							{
								saturation: -100
							}
						]
					}
				],
				map = new google.maps.Map( document.getElementById( 'map' ), mapOptions ),
				marker = new google.maps.Marker(
					{
						position: center,
						map: map,
						visible: true,
						icon: {
							url: '/wp-content/themes/ksv/assets/images/pin.png'
						}
					}
				);

				map.setOptions({
					styles: styles
				});

		},

		Helpers: {

			removeClass: function(el, className) {
				if (el.classList)
				  el.classList.remove(className);
				else
				  el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			},

			addClass: function(el, className) {
				if (el.classList)
				  el.classList.add(className);
				else
				  el.className += ' ' + className;
			}

		}
	};
}());

$( KSV.Initialise );